import GeneratedProjectTagServiceApi from "./generated/GeneratedProjectTagServiceApi"

class ProjectTagServiceApi extends GeneratedProjectTagServiceApi {

}

export const projectTagServiceApi = new ProjectTagServiceApi()
